<template>
  <div class="payment" id="payment">
    <van-form @submit="onSubmit" label-width="110px">
      <van-field
        v-model="subData.buyer_name"
        readonly
        name="buyer_name"
        label="客户"
        placeholder="请选择客户"
      />
      <van-field
        v-model="subData.debts"
        readonly
        name="buyer_name"
        label="应还(元)"
        type="number"
      />
      <div class="discount" id="">
        <div class="discount_btn">
          <span :class=" 1?'active':''" @click="subData.type = 1">优惠</span>
          <!-- <span :class="subData.type == 2?'active':''" @click="subData.type = 2">多收</span> -->
        </div>
        <div class="discount_input">
          <KeyBoardInput ref="discount_amount" :k_default_show="false" :k_isValueZero="true" v-model="subData.discount_amount"  k_appendToId="payment" :k_placeholder="placeholderData.discount_amount" :k_decimal="2" @input="changeDiscount">
            <template slot="input_right">元</template>
          </KeyBoardInput>
        </div>
      </div>
      <div class="discount">
        <div class="discount_btn">还款</div>
        <div class="discount_input">
          <KeyBoardInput ref="repayment" :k_default_show="false" :k_isValueZero="true" v-model="subData.repayment" k_appendToId="payment" :k_placeholder="placeholderData.repayment" :k_decimal="2" @input="changeDiscount">
            <template slot="input_right">元</template>
          </KeyBoardInput>
        </div>
        <div
          style="color:#f00;text-align:right;font-size:0.32rem"
          v-if="Number(subData.debts - subData.discount_amount - (subData.repayment != ''?subData.repayment:placeholderData.repayment)).toFixed(2)>0"
        >未还欠款 {{(subData.debts - subData.discount_amount - (subData.repayment != ''?subData.repayment:placeholderData.repayment)).toFixed(2)}}元</div>
      </div>
      <van-field name="checkboxGroup" label="支付方式" class="check_box_payment">
        <template #input>
          <van-radio-group
            v-model="subData.repayment_type"
            style="width:100%"
            checked-color="#31B158"
          >
            <van-cell-group colo>
              <van-cell
                v-for="(item,index) in pay_type"
                :key="index"
                :title="item.name"
                @click="subData.repayment_type = item.value"
              >
                <template #right-icon>
                  <van-radio :name="item.value" />
                </template>
              </van-cell>
            </van-cell-group>
          </van-radio-group>
        </template>
      </van-field>
      <div style="margin: 16px;" id="appsl">
        <van-button round block type="info" native-type="submit" color="#31b158">还款</van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import KeyBoardInput from "@/components/KeyBoardInput";
import { longtimestampToDate } from "@/utils/timestamp";
import { credit_payment_buyer,credit_payment_order } from "@/api/work/credit/credit";
export default {
  name: "payment",
  components:{
    KeyBoardInput
  },
  data() {
    return {
      pay_type: [
        { value: 1, name: "现金" },
        { value: 2, name: "支付宝" },
        { value: 3, name: "微信" },
        { value: 4, name: "银行卡" }
      ],
      subData: {
        credit_ids: "",
        buyer_id: "",
        buyer_name: "",
        debts: "",
        discount_amount: "",
        repayment: "",
        repayment_amount:'',
        repayment_type: 1,

        type: "1"
      },
      placeholderData:{
        discount_amount:'',
        repayment:""
      },

      showPicker: false
    };
  },
  created() {
    if (this.$route.query.type == 2) {
      this.subData.type = 2;
      var buyerData = JSON.parse(decodeURI(this.$route.query.item));
      this.subData.buyer_id = buyerData.buyer_id;
      this.subData.buyer_name = buyerData.buyer_name;
      this.subData.debts = buyerData.debts;
      // this.subData.repayment = buyerData.debts;
      this.placeholderData.discount_amount = 0;
      this.placeholderData.repayment = buyerData.debts;
    } else {
      this.subData.type = 1;
      var buyerData = JSON.parse(decodeURI(this.$route.query.item));
      console.log(buyerData)
      var subData = JSON.parse(this.$route.query.subData);
      this.subData.buyer_id = buyerData.buyer_id;
      this.subData.buyer_name = buyerData.buyer_name;
      this.subData.debts = subData.order_mount.toFixed(2);
      // this.subData.repayment = subData.order_mount.toFixed(2);
      this.subData.credit_ids = subData.order_id.join(",");
      this.placeholderData.discount_amount = 0;
      this.placeholderData.repayment = subData.order_mount;
    }
  },
  mounted() {},
  methods: {
    // 提交数据
    onSubmit() {
      this.subData.discount_amount = this.subData.discount_amount == ""?this.placeholderData.discount_amount:this.subData.discount_amount
      this.subData.repayment = this.subData.repayment == ""?this.placeholderData.repayment:this.subData.repayment
      if (this.subData.repayment.length == 0 || !(this.subData.repayment >= 0)) {
        this.$toast("请输入实收金额！");
        return false;
      }
      this.subData.repayment_amount = Number(this.subData.repayment) + Number(this.subData.discount_amount);
      if (this.subData.type == 1) {
        credit_payment_order(this.subData).then(res => {
          this.$toast.success(res.message);
          this.$router.go(-2);
        });
      } else {
        credit_payment_buyer(this.subData).then(res => {
          this.$toast.success(res.message);
          this.$router.go(-1);
        });
      }
    },

    onDateConfirm(date) {
      console.log(date);
      this.subData.date = longtimestampToDate(date);
      this.showPicker = false;
    },
    

    // 输入
    changeDiscount(value){
      console.log(value)
      var discount = this.subData.discount_amount - 0
      this.placeholderData.repayment = Number(this.subData.debts-0 - discount).toFixed(2)
    }
  }
};
</script>

<style lang="less" scoped>
.payment {
  position: relative;
  min-height: calc(100vh - 0.88rem);
  background-color: #fff;
  .discount {
    padding: 0.3rem 0.3rem 0;
    .discount_btn {
      font-size: 0.32rem;
      span {
        display: inline-block;
        line-height: 0.5rem;
        border: 0.02rem solid #31b158;
        background-color: #fff;
        border-radius: 0.25rem;
        padding: 0 0.3rem;
        margin-right: 0.1rem;
        &.active {
          background: #31b158;
          color: #fff;
        }
      }
    }
    .discount_input {
      margin-top: 0.2rem;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 0.32rem;
      line-height: 0.8rem;
      border: solid 0.02rem #31b158;
      box-sizing: border-box;
      padding-right: 0.2rem;
      border-radius: 0.1rem;
      overflow: hidden;
    }
  }
}
</style>

<style lang="less">
.check_box_payment {
  flex-wrap: wrap;
  flex: auto;
  .van-field__value {
    margin-top: 10px;
    width: 100%;
    flex: auto;
  }
}
</style>